import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { ResourceAvailability } from "@app/models/rest/resource-availability";

@Injectable({
  providedIn: "root"
})
export class ResourceAvailabilityRestService extends HateoasResourceOperation<ResourceAvailability> {
  constructor() {
    super(ResourceAvailability);
  }
}
